import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as firebase from "firebase";

@Injectable()
export class QuotationHistoryService {
    private db;
    quotation: FirebaseListObservable<Quotation[]>;
    quotations: FirebaseListObservable<Quotation[]>;
    user: FirebaseListObservable<User[]>

    constructor(private firebaseService: FirebaseService) {
        this.db = firebaseService.db;
        // this.loadQuotationDb;
        // this.loadQuotationDb();
    }

    // loadQuotationDb(){
    //     this.quotation = this.db.list('/quotation') as FirebaseListObservable<Quotation[]>
    //     return this.quotation;
    // }
    getUsers(uuid){
        this.user = this.db.list('/quotation/', {
            query: {
                orderByChild: 'uid',
                equalTo: 'uid'
            }
        }) as FirebaseListObservable<User[]>
    }

    getQuotations(){
        this.quotations = this.db.list('/all-quotation/') as FirebaseListObservable<Quotation[]>
        return this.quotations
    }

    getQuotationBasedOnUser(uid){
        // this.quotation = this.db.list('/quotation/'+key) as FirebaseListObservable<Quotation[]>
        // // console.log(this.quotation);
        // return this.quotation;
         this.quotation = this.db.list('/all-quotation/', {
            query: {
                orderByChild: 'uid',
                equalTo: uid
            }
        }) as FirebaseListObservable<User[]>
        return this.quotation;
    }

    getCompanyList(key){
        var company = this.db.list('/quotation/'+key)
    }

    getQuotationBasedOnCompany(company_key){
        this.quotation = this.db.list('/all-quotation/', {
            query: {
                orderByChild: 'company_key',
                equalTo: company_key
            }
        }) as FirebaseListObservable<Quotation[]>
        console.log(company_key);
        return this.quotation;
    }

    getSingleQuotation(quotation_key) {
        console.log('dan ini quote key : '+quotation_key);
        return this.db.object('/all-quotation/'+quotation_key) as FirebaseObjectObservable<Quotation>;
    }

}

export class User {
    $key?:string;
    fullname?:string;
    employee_number?:string
}

export class Quotation {
    $key?:string;
    company?: {
        attn?: string;
        city?: string;
        country_key?: string;
        created_at?: string;
        email?: string;
        fax?: string;
        key?: string;
        name?: string;
        phone?: string;
        postal_code?: string;
        street_one?: string;
        street_two?: string;
        type?: string;
        updated_at?: string;
    }
    company_key?: string
    created_at?: number
    from?: string
    incoterm?: string
    intro?: string
    key?: string
    lead_time?: string
    list?: {
        $key?:string;
        created_at?: number
        ingredient?: {
            application_suggestion?: string
            category_id?: string
            color_shade?: string
            color_shade_id?: string
            created_at?: number
            description?: string
            doc_MSDS?: string
            doc_TDS?: string
            doc_halal?: string
            doc_spec?: string
            ecoll_status?: string
            format?: string
            gin?: string
            gin_id?: string
            halal_status?: string
            key?: string
            lead_time?: string
            moq?: string
            moqString?: string
            packagingSizeString?: string
            packaging_size?: string
            pigment?: string
            pigment_id?: string
            price?: number
            product_list?: string
            product_name?: string
            product_status?: string
            shelf_life?: number
            solubility?: string
            tonality?: string
            tonality_id?: string
            updated_at?: number
        }
        ingredient_key?: string
        price?: string
        selected_moq?: string
        selected_packing_size?: string
        update_at?: number    
    }
    name?: string
    packing?: string
    payment?: string
    shipment?: string
    showPosition?: string
    status?: string
    subject?: string
    tax?: string
    template?: string
    uid?: string
    until?: string
    updated_at?: number
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/quotation-history.service.ts